import React, { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
}

const Card: React.FC<CardProps> = ({ children }) => {
  return <div className="bg-white rounded-3xl p-5">{children}</div>;
};

export default Card;
